export { FooterGlobalAccredditationsIcons } from './FooterGlobalAccreditationsIcons'
